const {} = require('./array-fill');
const {} = require('./array-move');
const {} = require('./array-includes');
const {} = require('./array-remove');

const {} = require('./string-trim');
const {} = require('./string-starts-with');
const {} = require('./string-ends-with');
const {} = require('./string-match-all');
const {} = require('./string-format');

import objectValuesPolifill from 'object.values';

if (!Object.values) {
    objectValuesPolifill.shim();
}



module.exports = {};